/* eslint-disable */
import React from 'react';

const If: React.FC<{ condition: boolean }> = (props) => {
  return <>{!!props.condition ? props.children : null}</>;
};

export default If;
